angular.module 'zc.users'

.directive 'userMenu', ($state, Agency, Devise, Project) ->
  directive =
    restrict: "EA"
    scope: {
      logoutOnly: "="
    }
    replace: true
    templateUrl: '/templates/users/views/directives/user_menu.html'
    link: (scope, element, attrs) ->

      scope.Devise = Devise

      scope.Project = Project
      scope.agency = null

      Agency.all().then (agencies) ->
        scope.agency = agencies[0]

      attrs.$observe "logoutOnly", () ->
        scope.logoutOnly = scope.$eval(attrs.logoutOnly)

      scope.$watch "Project.currentProject", (newVal, oldVal) ->
        if newVal
          scope.projectId = newVal.id

      Devise.getCurrentUser().then (res) ->
        scope.currentUser = res

      scope.signOut = Devise.signOut


  directive



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/users/directives/user_menu_directive.js.coffee